import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSiteSettings } from "../contexts/SiteSettingsContext";
import { initPixel, pageView } from "../lib/metaPixel";
import { sendFunnelEvent } from "../lib/funnelEvents";

/**
 * Initialises Meta Pixel from CMS settings and fires PageView on every
 * client-side route change. Drop once at the router root.
 */
export default function MetaPixelTracker() {
    const { settings } = useSiteSettings();
    const { pathname, search } = useLocation();
    const pixelId = (settings?.meta_pixel_id || "").trim();

    useEffect(() => {
        if (pixelId) initPixel(pixelId);
    }, [pixelId]);

    useEffect(() => {
        if (pixelId) pageView();
        const cleanPath = pathname || "/";
        if (!cleanPath.startsWith("/admin") && !cleanPath.startsWith("/panel")) {
            sendFunnelEvent("view_content", {
                page_path: cleanPath,
                page_title: document.title,
                content_name: cleanPath,
                content_category: "public_page",
            });
        }
    }, [pathname, search, pixelId]);

    return null;
}
